import { input } from '@albacross/frontend-utils'

import BaseSelect from './BaseSelect'

export default input('')(BaseSelect)
